import { useEffect, useState } from "react";
const API = "/api";
const token = () => localStorage.getItem("token");

export default function Dashboard() {
  const [stats, setStats] = useState({productos:0,pedidos:0,resenas:0,categorias:0});

  useEffect(() => {
    const h = {Authorization:`Bearer ${token()}`};
    Promise.all([
      fetch(`${API}/productos/`).then(r=>r.json()),
      fetch(`${API}/pedidos/`,{headers:h}).then(r=>r.json()),
      fetch(`${API}/resenas/admin`,{headers:h}).then(r=>r.json()),
      fetch(`${API}/categorias/`).then(r=>r.json()),
    ]).then(([p,pe,re,c]) => setStats({
      productos:Array.isArray(p)?p.length:0,
      pedidos:Array.isArray(pe)?pe.length:0,
      resenas:Array.isArray(re)?re.length:0,
      categorias:Array.isArray(c)?c.length:0
    })).catch(()=>{});
  },[]);

  const cards = [
    {label:"Productos",value:stats.productos,ico:"📦",color:"#1565C0"},
    {label:"Pedidos",value:stats.pedidos,ico:"🛒",color:"#7c3aed"},
    {label:"Resenas",value:stats.resenas,ico:"⭐",color:"#d97706"},
    {label:"Categorias",value:stats.categorias,ico:"🏷️",color:"#059669"},
  ];

  return (
    <div>
      <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,marginBottom:"24px",color:"#1a1a2e"}}>Dashboard</h1>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"16px",marginBottom:"32px"}}>
        {cards.map(c => (
          <div key={c.label} style={{background:"#fff",borderRadius:"16px",padding:"24px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)",borderLeft:`4px solid ${c.color}`}}>
            <div style={{fontSize:"32px",marginBottom:"8px"}}>{c.ico}</div>
            <div style={{fontFamily:"Montserrat,sans-serif",fontSize:"32px",fontWeight:900,color:c.color}}>{c.value}</div>
            <div style={{fontSize:"13px",color:"#6b7280",fontWeight:600}}>{c.label}</div>
          </div>
        ))}
      </div>
      <div style={{background:"#fff",borderRadius:"16px",padding:"24px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
        <h2 style={{fontFamily:"Montserrat,sans-serif",fontSize:"16px",fontWeight:900,marginBottom:"16px",color:"#1a1a2e"}}>Accesos rapidos</h2>
        <div style={{display:"flex",gap:"12px",flexWrap:"wrap"}}>
          {[["📦 Agregar producto","/productos"],["🏷️ Nueva categoria","/categorias"],["🛒 Ver pedidos","/pedidos"],["⭐ Aprobar resenas","/resenas"]].map(([l,p]) => (
            <a key={p} href={p} style={{background:"#EFF6FF",color:"#1565C0",padding:"10px 20px",borderRadius:"10px",fontWeight:700,fontSize:"13px",textDecoration:"none"}}>{l}</a>
          ))}
        </div>
      </div>
    </div>
  );
}
